import { useLocation } from "react-router-dom";

import { EndScreenCase } from "@/components/endScreens";
import { NewIntakeLayout } from "@/layout";
import { useMultiStepFormStore } from "@/stores";
import { PATIENT_STATUS } from "@/utils";

interface EndScreenTransferredLocationState {
  dmeProvider: string;
}

export const EndScreenTransferred = () => {
  const location = useLocation();
  const state = location.state as EndScreenTransferredLocationState;
  const { dmeProvider } = state;
  const { multiStepFormData } = useMultiStepFormStore();
  const generalInformationFormData =
    multiStepFormData?.generalInformationFormData;

  if (!generalInformationFormData) {
    return null;
  }
  return (
    <NewIntakeLayout isEndScreen>
      {dmeProvider ? (
        <EndScreenCase
          status={PATIENT_STATUS.TRANSFERRED}
          title={"Registration Complete"}
          description={`As Quest cannot currently service this request, please transfer to ${dmeProvider} to continue the process.`}
          hasDme={true}
        />
      ) : (
        <EndScreenCase
          status={PATIENT_STATUS.TRANSFERRED}
          title={"No providers found"}
          description={`We couldn’t find any DME providers for the patient’s insurance in their state.`}
        />
      )}
    </NewIntakeLayout>
  );
};
